import { Box, Container, Typography } from '@mui/material'
import { InitializationWrapper } from '@planning/components'
import { useTranslate } from '@tolgee/react'
import { useMinimalsTheme } from '@tom-ui/ui'
import { useAsyncFetch } from '@tom-ui/utils'
import { observer } from 'mobx-react-lite'
import { useMemo } from 'react'
import { VesselBookingHeader } from './Components/organisms/VesselBookingHeader'
import { VesselBookingSummary } from './Components/organisms/VesselBookingSummary'
import { VesselBookingTable } from './Components/organisms/VesselBookingTable'
import { VesselBookingsViewStore } from './Stores/VesselBookingsViewStore'

export const VesselBookingsPage = observer(() => {
  const theme = useMinimalsTheme()
  const { t } = useTranslate()

  const store = useMemo(() => new VesselBookingsViewStore(), [])
  const { loading, error } = useAsyncFetch(async () => {
    store.fetchSummary()
  }, [store])

  if (error) {
    return <Typography variant='h4'>{t('errorLoadingIssues', 'Error loading issues')}</Typography>
  }

  return (
    <InitializationWrapper isInitializing={loading}>
      <Box
        sx={{
          height: '100%',
          bgcolor: theme.palette.grey[100],
        }}
      >
        <VesselBookingHeader />

        <Container sx={{ paddingY: 2 }}>
          <VesselBookingSummary data={store.summary} />
          <VesselBookingTable store={store} />
        </Container>
      </Box>
    </InitializationWrapper>
  )
})
